import styles from './ShareShoppingCart.module.scss'
import Button from '@/components/buttons/Button/Button'
import Modal from '@/components/common/Modal/Modal'
import DefaultInput from '@/components/inputs/DefaultInput/DefaultInput'
import { useTranslation } from 'next-i18next'
import React from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useAddShoppingListMutation } from '@/api/shoppingList'
import Form from '@/components/common/Form/Form'
import ButtonLink from '@/components/buttons/ButtonLink/ButtonLink'
import CopyIcon from '@/assets/svg/copy.svg'
import { useSnackbar } from '@/utils/hooks/useSnackbar'
import LoadingOverlay from '@/components/common/LoadingOverlay/LoadingOverlay'

type Props = {
  onClose: () => void
}

const ShareShoppingCart = (props: Props) => {
  const { t } = useTranslation(['common', 'cart'])
  const [createLink, { isLoading }] = useAddShoppingListMutation()
  const [link, setLink] = React.useState<string>('')
  const { showSnackbar } = useSnackbar()

  const Schema = Yup.object().shape({
    name: Yup.string()
      .required(t('common:validation.required') || '')
      .max(30, t('common:validation.maxLength', { length: 30 }) || '')
      .matches(/^[a-zA-Z0-9 ]*$/, t('common:validation.onlyLettersNumbersAndSpace') || '')
  })

  const formik = useFormik({
    initialValues: {
      name: '',
    },
    validationSchema: Schema,
    onSubmit: values => {
      createLink(values)
        .unwrap()
        .then((data) => {
          setLink(data)
        })
        .catch(() => {
          showSnackbar(t('common:error'), "error")
        })
    },
  })


  // get curent url of the site including protocol, like http or https
  const currentUrl = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')

  const buildLink = (linkId: string) => {
    return `${currentUrl}/cart?shoppinglist=${linkId}`
  }

  const onCopyLink = () => {
    navigator.clipboard.writeText(buildLink(link))
    showSnackbar(t('common:copiedToClipboard'))
  }

  return (
    <div>
      <Modal
        onClose={props.onClose}
        title={t('cart:shareShoppingCart')}
        className={styles.modal}
        clickOutsideToClose={true}
      >
        <div>
          {!link && (
            <Form
              onSubmit={formik.handleSubmit}
            >
              {isLoading && <LoadingOverlay />}
              <DefaultInput
                name="name"
                inputStyle='border'
                label={t('cart:shoppingListName')}
                value={formik.values.name}
                onChangeEvent={formik.handleChange}
                error={formik.errors.name}
              />
              <p><i>{t('cart:nameWillBeShown')}</i></p>
              <div className="flex right margin-top-1">
                <Button
                  label={t('common:generateLink')}
                  type="submit"
                  rounded={true}
                />
              </div>
            </Form>
          )}
          {link && (
            <div>
              <DefaultInput
                value={`${buildLink(link)}`}
                name={''}
                label={t('common:link')}
                disabled={true}
              />
              <div className={styles.copyLink}>
                <ButtonLink
                  label={t('common:copy')}
                  icon={CopyIcon}
                  onClick={onCopyLink}
                />
              </div>
              <p>{t('cart:copyGeneratedLinkAndShare')}</p>
              <div className="flex right margin-top-1">
                <Button
                  label={t('common:close')}
                  type="submit"
                  rounded={true}
                  onClick={props.onClose}
                />
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  )
}

export default ShareShoppingCart